import { getNearEnv } from './config';

export default function getConfig(
  nearEnv: string = process.env.REACT_APP_NEAR_ENV
) {
  const common = {
    // Upstream DCL (concentrated liquidity) pool lists and LP "shadow" pool ids.
    // Empty until you deploy those contracts.
    ORDERBOOK_COLLATERAL_TOKEN: '',
    BLACK_LIST_DCL_POOL_IDS_IN_POOLS: [] as string[],
    WHITE_LIST_DCL_POOL_IDS_IN_LIMIT_ORDERS: [] as string[],
    SUPPORT_SHADOW_POOL_IDS: [] as string[],
  };

  if (getNearEnv(nearEnv) === 'mainnet') {
    return {
      ...common,
      // Circle's native USDC does not require storage registration.
      NO_REQUIRED_REGISTRATION_TOKEN_IDS: [
        '17208628f84f5d6ad33f0da3bbbeb27ffcb398eac501a31bd6ad2011e36133a1',
      ],
      NATIVE_TOKENS: [
        'usdt.tether-token.near',
        '17208628f84f5d6ad33f0da3bbbeb27ffcb398eac501a31bd6ad2011e36133a1',
      ],
    };
  }
  return {
    ...common,
    NO_REQUIRED_REGISTRATION_TOKEN_IDS: [] as string[],
    NATIVE_TOKENS: [] as string[],
  };
}
